import React from 'react'

export default function AboutContent() {
  return (
    <section className="bg_white pt-90 pb-160 ">
    <div className="container">
      <div className="description-widget">
        <div className="row">
          <div className="col-md-4">
            <div className="desc-title text-end bg_primary">
              <h2>A journey that started with a belief to Bank Different</h2>
            </div>
          </div>
          <div className="col-md-8">
            <div className="desc-text pl-lg-10">
              <p>
                Bank shoppy’s journey started with a single belief to connect
                people, places and possibilities by doing things others said could
                not be done. Anchored on this belief, the Bank was founded in 2017
                and we are, to date, headquartered in the Mauritius International
                Financial Centre with a representative office in United States.
              </p>
              <p className="mt-20">
                Bank shoppy's core banking and transactional capabilities are also
                complemented. Bank shoppy experienced team and its regional foundation
                are complemented by the belief and trust our clients have in our
                ability to connect them to a global banking network to seamlessly
                achieve their financial aspirations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}
